
import {filter} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd} from '@angular/router';

import { AuthService, StorageService } from '@shared/index';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  navigations: any = [];
  items: any = [];
  parentRoute = '';
  breadcrumbList: any = [];
  activeOrderPage = '';
  loadingNavigation: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private storage: StorageService
  ) {
    this.buildItems();
  }

  ngOnInit() {
    this.router.events.pipe(
    filter(event => event instanceof NavigationEnd))
    .subscribe(e => {
      if (e instanceof NavigationEnd) {
        if (e.url !== '/login') {
          this.buildItems();
        }
      }
    });
    this.route.params.subscribe(params => {
      this.findRouteData();
    })
  }

  buildItems() {
    const url: string = this.route.snapshot.firstChild.url.join('');
    this.parentRoute = url;
    this.findRouteData();
    this.loadingNavigation = true;
    if (this.storage.retrieve('leftNavigation', 'session')) {
      this.loadingNavigation = false;
      const leftMenu = this.storage.retrieve('leftNavigation', 'session');
      this.items = typeof leftMenu[url] !== 'undefined' ? leftMenu[url] : [];
    } else {
      this.storage.observe('leftNavigation', 'session')
      .subscribe((value) => {
        setTimeout(() => {
          this.loadingNavigation = false;
          const leftMenu = this.storage.retrieve('leftNavigation', 'session');
          if (leftMenu) {
            this.items = typeof leftMenu[url] !== 'undefined' ? leftMenu[url] : [];
          }
        });
      }, error => {
        this.loadingNavigation = false;
      });
    }
  }

  findRouteData() {
    this.breadcrumbList = [];
    let currentRoute = this.route.root,
    url = '';
    do {
      const childrenRoutes = currentRoute.children;
      currentRoute = null;
      childrenRoutes.forEach(routes => {
        if (routes.outlet === 'primary') {
          const routeSnapshot = routes.snapshot;
          if (routeSnapshot && routeSnapshot.url) {
            url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
          }
          if (routeSnapshot && routeSnapshot.data && routes.snapshot.data.breadcrumb !== undefined && routes.snapshot.data.breadcrumb !== '') {
            if (routes.snapshot.data.parent === 'orders' && routes.snapshot.data.breadcrumb === 'Details' && this.storage.retrieve('activeOrderPage') && this.storage.retrieve('activeOrderPage') !== '') {
              const page = this.storage.retrieve('activeOrderPage').replace(/-/g, ' ').toLowerCase();
              this.breadcrumbList.push(page);
              this.breadcrumbList.push(this.storage.retrieve('activeOrderPage'));
            }
            const breadcrumb = routes.snapshot.data.breadcrumb.toLowerCase();
            if (routes.snapshot.data.slug) {
              const slug = routes.snapshot.data.slug.toLowerCase();
              this.breadcrumbList.push(slug);
            }
            this.breadcrumbList.push(breadcrumb);
          }
          currentRoute = routes;
        }
      });
    } while (currentRoute);
  }

  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }

}
